import React, { useState, useEffect } from "react";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios"; // Importamos axios (aunque lo usaremos simulado por ahora)

function CreateTemplatePage() {
  const [templateName, setTemplateName] = useState("");
  const [templateContent, setTemplateContent] = useState("");
  const { id } = useParams();
  const { quill, quillRef } = useQuill({
    modules: {
      toolbar: [
        ["bold", "italic", "underline", "strike"],
        ["blockquote", "code-block"],
        [{ header: 1 }, { header: 2 }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ direction: "rtl" }],
        [{ size: ["small", false, "large", "huge"] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ color: [] }, { background: [] }],
        [{ font: [] }],
        [{ align: [] }],
        ["clean"],
      ],
    },
    formats: [
      "bold",
      "italic",
      "underline",
      "strike",
      "blockquote",
      "code-block",
      "header",
      "list",
      "bullet",
      "script",
      "indent",
      "direction",
      "size",
      "color",
      "background",
      "font",
      "align",
    ],
    theme: "snow",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      // Simulación de la carga de la plantilla desde el backend por ID
      setTimeout(() => {
        const fetchedTemplate = {
          id: parseInt(id),
          name: `Plantilla ${id}`,
          content: `<p>Contenido de la plantilla con ID ${id}. Puedes editar esto.</p>`,
        };
        setTemplateName(fetchedTemplate.name);
        setTemplateContent(fetchedTemplate.content);
        setIsLoading(false);
      }, 1000);
    }
  }, [id]);

  useEffect(() => {
    if (quill) {
      quill.on("text-change", () => {
        setTemplateContent(quill.root.innerHTML);
      });
      if (templateContent) {
        quill.root.innerHTML = templateContent;
      }
    }
  }, [quill, templateContent]);

  const handleNameChange = (event) => {
    setTemplateName(event.target.value);
  };

  const handleSaveTemplate = async () => {
    setIsLoading(true);
    setError("");
    const templateData = {
      name: templateName,
      content: templateContent,
    };

    try {
      // Simulación de la llamada a la API
      await new Promise((resolve) => setTimeout(resolve, 1500));

      if (id) {
        console.log(
          "Simulando petición PUT/PATCH al backend para actualizar la plantilla con ID:",
          id,
          templateData
        );
        // En una aplicación real: await axios.put(`/templates/${id}`, templateData);
      } else {
        console.log(
          "Simulando petición POST al backend para guardar nueva plantilla:",
          templateData
        );
        // En una aplicación real: const response = await axios.post('/templates', templateData);
        // Podrías obtener el ID de la nueva plantilla desde la respuesta y redirigir.
      }

      setIsLoading(false);
      navigate("/admin/templates"); // Redirigir de vuelta a la lista de plantillas
    } catch (error) {
      console.error("Error al guardar la plantilla:", error);
      setError(
        "Hubo un error al guardar la plantilla. Por favor, inténtalo de nuevo."
      );
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <p>Guardando plantilla...</p>;
  }

  if (error) {
    return <p className="error-message">{error}</p>;
  }

  return (
    <div>
      <h2>{id ? "Editar Plantilla" : "Crear Nueva Plantilla"}</h2>

      <div>
        <label htmlFor="templateName">Nombre de la Plantilla:</label>
        <input
          type="text"
          id="templateName"
          value={templateName}
          onChange={handleNameChange}
          placeholder="Ej: Plantilla de Curso Avanzado"
        />
      </div>

      <div className="editor-container">
        <div ref={quillRef} style={{ height: 300 }} />
      </div>

      <button onClick={handleSaveTemplate} disabled={isLoading}>
        {isLoading ? "Guardando..." : "Guardar Plantilla"}
      </button>
    </div>
  );
}

export default CreateTemplatePage;
